import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { ButtonUI, CustomThemeProvider, Prompt, usePortal } from 'sonata-react-components';
import { useTheme } from 'styled-components';

import './excludeRetargetingPrompt.scss';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

function ExcludeRetargetingPrompt({ onCancel, onConfirm }: Props) {
  const { formatMessage } = useIntl();
  const { name: themeName }: Record<string, any> = useTheme();
  const targetBodyPrompt = usePortal('excludeRetargetingPrompt');

  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast={themeName.toLowerCase()}>
      <Prompt className="excludeRetargetingPrompt" closePrompt={onCancel} width="600px">
        <Prompt.Title>
          {formatMessage({
            defaultMessage: 'Your campaign will no longer include retargeting',
            id: 'targeting.audienceTargeting.excludeRetargetingPrompt.title'
          })}
        </Prompt.Title>
        <Prompt.Description>
          {formatMessage({
            defaultMessage:
              'Excluding this audience profile will prevent your ads from being shown to anyone who has already visited the specified zones. Are you sure you want to proceed?',
            id: 'targeting.audienceTargeting.excludeRetargetingPrompt.description'
          })}
        </Prompt.Description>
        <Prompt.Buttons position="centered">
          <ButtonUI
            id="excludeRetargetingPrompt-cancelButton"
            onClick={onCancel}
            shape="squareRounded"
            size="medium"
            text={formatMessage({ defaultMessage: 'Cancel', id: 'common.cancel' })}
            type="secondary"
          />
          <ButtonUI
            id="excludeRetargetingPrompt-confirmButton"
            onClick={onConfirm}
            shape="squareRounded"
            size="medium"
            text={formatMessage({ defaultMessage: 'Confirm', id: 'common.confirm' })}
            type="primary"
          />
        </Prompt.Buttons>
      </Prompt>
    </CustomThemeProvider>,
    targetBodyPrompt
  );
}

export default ExcludeRetargetingPrompt;
